module.exports = __webpack_public_path__ + "535877f50039c0cb49a6196a5b7517cd.woff";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 136
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19